// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AHG0","colBig":"styles_colBig__2bcTC","colSmall":"styles_colSmall__3j0q-","shopifyNameWrapper":"styles_shopifyNameWrapper__2glEr"};